module.exports = __webpack_public_path__ + "img/call-center.54bd93cc.webp";